(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  let raf = null;
  let pointerX = 0;
  let pointerY = 0;

  const boundTriggers = new WeakSet();
  const observedDisclosures = new WeakSet();


  /* =========================================================
     OBTENER ITEMS PRINCIPALES
     ========================================================= */

  function getHeaderMenu() {
    return document.querySelector('header-menu');
  }

  function getTopItems() {
    const headerMenu = getHeaderMenu();

    if (!headerMenu) return [];

    return [
      ...headerMenu.querySelectorAll('.menu-list__list-item')
    ].filter((item) => {

      if (item.getAttribute('slot') === 'overflow') {
  return false;
}

      /* Solo nivel principal */
      if (item.closest('header-menu') !== headerMenu) {
        return false;
      }

      return Boolean(getTrigger(item));
    });
  }


  /* =========================================================
     HELPERS
     ========================================================= */

  function getTrigger(item) {
    return (
      item.querySelector(':scope > .menu-list__trigger') ||
      item.querySelector(':scope > .menu-list__link')
    );
  }


  function getSubmenu(item) {
    return item.querySelector(
      ':scope > .menu-list__submenu'
    );
  }


  function getDisclosure(item) {
    const trigger =
      item.querySelector(':scope > .menu-list__trigger');

    if (!trigger) return null;

    return (
      trigger.querySelector(
        '.menu-list__disclosure[aria-expanded]'
      ) ||
      trigger.querySelector('[aria-expanded]')
    );
  }


  /* =========================================================
     ESTADO VISUAL NARANJA
     ========================================================= */

  function setHoverItem(activeItem) {
    getTopItems().forEach((item) => {
      item.classList.toggle(
        'am-menu-hover',
        item === activeItem
      );
    });
  }


  function setActiveItem(activeItem) {
    getTopItems().forEach((item) => {
      item.classList.toggle(
        'am-menu-active',
        item === activeItem
      );
    });
  }


  /* =========================================================
     ALTURA
     No abre/cierra nada.
     Solo corrige la altura DESPUÉS de que Horizon abrió.
     ========================================================= */

  function syncHeight(item) {
    if (
      !item.classList.contains('am-menu-active')
    ) {
      return;
    }

    const submenu = getSubmenu(item);
    const header =
      item.closest('header-component');

    if (!submenu || !header) return;

    const inner =
      submenu.querySelector(
        '.menu-list__submenu-inner'
      ) || submenu;

    const grid =
      submenu.querySelector('.mega-menu__grid');

    const innerHeight =
      Math.ceil(inner.scrollHeight || 0);

    const gridHeight = grid
      ? Math.ceil(
          Math.max(
            grid.scrollHeight || 0,
            grid.getBoundingClientRect().height || 0
          )
        )
      : 0;

    const submenuHeight =
      Math.max(innerHeight, gridHeight) + 8;

    if (submenuHeight <= 0) return;

    const styles = getComputedStyle(header);

    const headerHeight =
      parseFloat(
        styles.getPropertyValue('--header-height')
      ) || header.offsetHeight;

    header.style.setProperty(
      '--submenu-height',
      `${submenuHeight}px`
    );

    header.style.setProperty(
      '--full-open-header-height',
      `${headerHeight + submenuHeight}px`
    );
  }


  function scheduleHeightSync(item) {

    requestAnimationFrame(() => {

      requestAnimationFrame(() => {
        syncHeight(item);
      });

    });

    setTimeout(() => {
      syncHeight(item);
    }, 80);

    setTimeout(() => {
      syncHeight(item);
    }, 200);
  }


  /* =========================================================
     OBSERVAR ESTADO NATIVO DE HORIZON
     ========================================================= */

  function observeNativeState() {

    getTopItems().forEach((item) => {

      const disclosure =
        getDisclosure(item);

      if (!disclosure) return;

      if (
        observedDisclosures.has(disclosure)
      ) {
        return;
      }

      observedDisclosures.add(disclosure);


      const updateState = () => {

        const isOpen =
          disclosure.getAttribute(
            'aria-expanded'
          ) === 'true';


        if (isOpen) {

          /*
           * Horizon abrió correctamente el menú.
           * Recién aquí marcamos nuestro estado activo.
           */
          setActiveItem(item);

          scheduleHeightSync(item);

        } else {

          item.classList.remove(
            'am-menu-active'
          );

        }

      };


      const observer =
        new MutationObserver(updateState);

      observer.observe(disclosure, {
        attributes: true,
        attributeFilter: [
          'aria-expanded'
        ]
      });

    });
  }


  /* =========================================================
     HOVER VISUAL INMEDIATO
     ========================================================= */

  function bindVisualHover() {

    getTopItems().forEach((item) => {

      const trigger =
        getTrigger(item);

      if (!trigger) return;

      if (
        boundTriggers.has(trigger)
      ) {
        return;
      }

      boundTriggers.add(trigger);


      trigger.addEventListener(
        'pointerenter',
        () => {

          if (!desktop.matches) return;

          /*
           * El naranja comienza inmediatamente.
           */
          setHoverItem(item);

        },
        { passive: true }
      );


      trigger.addEventListener(
        'pointerleave',
        () => {

          /*
           * Si sigue siendo el submenu abierto,
           * am-menu-active mantiene el naranja.
           */
          item.classList.remove(
            'am-menu-hover'
          );

        },
        { passive: true }
      );

    });

  }


  /* =========================================================
     FIX REAL PARA ENTRAR DESDE ABAJO
     ========================================================= */

function detectPointerTarget() {
  raf = null;

  if (!desktop.matches) return;

  const headerMenu = getHeaderMenu();

  if (!headerMenu) return;


  for (const item of getTopItems()) {

    const trigger =
      getTrigger(item);

    if (!trigger) continue;


    const rect =
      trigger.getBoundingClientRect();


    const inside =
      pointerX >= rect.left &&
      pointerX <= rect.right &&
      pointerY >= rect.top &&
      pointerY <= rect.bottom;


    if (!inside) continue;


    /*
     * HOVER NARANJA INMEDIATO
     */
    setHoverItem(item);


    const submenu =
      getSubmenu(item);


    /*
     * Comprobamos si Horizon ya considera
     * este item abierto.
     *
     * Horizon 3.5.1 guarda aria-expanded
     * en [ref="menuitem"].
     */
    const nativeMenuItem =
      item.querySelector('[ref="menuitem"]');


    const alreadyOpen =
      nativeMenuItem?.getAttribute(
        'aria-expanded'
      ) === 'true';


    /*
     * Si ya está abierto, no hacemos nada.
     */
    if (alreadyOpen) {
      return;
    }


    /*
     * =====================================================
     * FIX ENTRADA DESDE ABAJO
     * =====================================================
     *
     * NO usamos dispatchEvent(pointerenter).
     *
     * Llamamos directamente a activate(),
     * que es el método nativo de HeaderMenu.
     *
     * Así evitamos depender de que Shopify
     * capture correctamente un evento sintético.
     */
    if (
      typeof headerMenu.activate === 'function'
    ) {

      headerMenu.activate({
        target: item,
        type: 'pointerenter'
      });

    }


    /*
     * Sincronizamos nuestras clases visuales
     * inmediatamente después de que Horizon
     * hizo su apertura.
     */
    if (submenu) {

      setActiveItem(item);

      scheduleHeightSync(item);

    } else {

      /*
       * Si Ofertas / Outlet / otro item
       * no tiene submenu, ninguno queda
       * marcado como activo.
       */
      getTopItems().forEach((other) => {
        other.classList.remove(
          'am-menu-active'
        );
      });

    }


    return;
  }
}


  function handlePointerMove(event) {

    if (!desktop.matches) return;

    pointerX = event.clientX;
    pointerY = event.clientY;


    if (raf !== null) return;


    raf =
      requestAnimationFrame(
        detectPointerTarget
      );

  }


  /* =========================================================
     INIT
     ========================================================= */

  function init() {

    bindVisualHover();

    observeNativeState();

  }


  init();


  document.addEventListener(
    'pointermove',
    handlePointerMove,
    { passive: true }
  );


  /* Shopify Editor */

  document.addEventListener(
    'shopify:section:load',
    () => {
      init();
    }
  );


  /* =========================================================
     RESIZE
     ========================================================= */

  window.addEventListener(
    'resize',
    () => {

      if (!desktop.matches) return;

      const active =
        document.querySelector(
          'header-menu .menu-list__list-item.am-menu-active'
        );

      if (active) {
        scheduleHeightSync(active);
      }

    },
    { passive: true }
  );


  /* =========================================================
     MOBILE
     ========================================================= */

  desktop.addEventListener?.(
    'change',
    (event) => {

      if (event.matches) {
        init();
        return;
      }

      getTopItems().forEach((item) => {

        item.classList.remove(
          'am-menu-active',
          'am-menu-hover'
        );

      });

    }
  );
/* =========================================================
   LIMPIEZA DE HOVER / ACTIVE PEGADO
   ========================================================= */

document.addEventListener(
  'pointermove',
  (event) => {
    if (!desktop.matches) return;

    const headerMenu =
      document.querySelector('header-menu');

    if (!headerMenu) return;

    const activeSubmenu =
      headerMenu.querySelector(
        '.menu-list__list-item.am-menu-active > .menu-list__submenu'
      );

    /*
     * Si el mouse sigue dentro del header
     * o dentro del submenu abierto,
     * mantenemos el estado.
     */
    const insideHeader =
      headerMenu.contains(event.target);

    const insideSubmenu =
      activeSubmenu?.contains(event.target);

    if (insideHeader || insideSubmenu) {
      return;
    }

    /*
     * El cursor ya salió completamente:
     * quitamos cualquier estado visual pegado.
     */
    headerMenu
      .querySelectorAll(
        '.am-menu-hover, .am-menu-active'
      )
      .forEach((item) => {
        item.classList.remove(
          'am-menu-hover',
          'am-menu-active'
        );
      });
  },
  { passive: true }
);
})();